// import logo from './logo.svg';
import './App.css';
import Covid from './components/covid'

function App() {
  return (
      <>
        
              <Covid/>
      </>
  );
}

export default App;
